// unit: filter3
import f from "../../../../funcs";
import Operator from "./Operator";


const Has = Operator.extend("Has", {
    literal: ["has", "@>"],

    compile2js(left, right) {
        if ( right == null ) {
            return false;
        }

        if ( f.isArray(right) ) {
            if ( !right.length ) {
                return "false";
            }
        } else {
            right = [ right ];
        }

        let result = "f.isArray(" + left + ") && (";
        let firstPass = true;

        for ( let rightElem of right ) {
            if ( rightElem == null ) {
                return false;
            }

            if ( !firstPass ) {
                result += " && ";
            } else {
                firstPass = false;
            }

            result += left + ".includes(" + JSON.stringify(rightElem) + ")";
        }

        result += ")";
        return result;
    }
});

export default Has;
